// extracted by css-extract-rspack-plugin
export default {"wrapper":"_984ae66c"};